import useViewModel from "./viewModel";
import View from "./view";

const ServicePaymentPlans = () => {
  const vieModel = useViewModel();
  return <View {...vieModel} />;
};

export default ServicePaymentPlans;
